import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import type { TreatmentTypeUnion } from '@chiroup/core/types/Treatment.type';

type paramsType = {
  type: TreatmentTypeUnion;
  hide: boolean;
  categories?: string[];
};

const treatmentService = () => {
  const list = async (clinicId?: number, params?: paramsType): Promise<{ data: any[] }> => {
    return ChiroUpAPI.get('api', `/${clinicId}/treatment`, {
      queryParams: params,
    });
  };

  return {
    list,
  };
};

export default treatmentService();
